import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchPaymentHistory = async (
  clientId,
  pageNumber,
  pageSize,
  sortOrder = "asc",
  sortBy = "DueDate"
) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_PAYMENT_HISTORY}/${clientId}?sortBy=${sortBy}&sortOrder=${sortOrder}&PageNumber=${pageNumber}&PageSize=${pageSize}`
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const updatePaymentDetailsAPI = async (clientId, paymentDetails) => {
  try {
    const response = await axiosInstance.post(
      `${Endpoints.UPDATE_PAYMENT_DETAILS}/${clientId}`,
      paymentDetails
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const pauseClientSubscriptionAPI = async ({
  clientId,
  resumeDate,
  coachId
}) => {
  const payload = {
    clientId,
    resumeDate,
    createdBy: coachId,
    updatedby: coachId,
  };
  try {
    const response = await axiosInstance.post(
      `${Endpoints.PAUSE_CLIENT_SUBSCRIPTION}`,
      payload
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};

export const endClientSubscriptionAPI = async ({
  clientId,
  endImmediately,
  endAfterBilling,
  coachId,
}) => {
  const payload = {
    clientId,
    endImmediately,
    endAfterBilling,
    createdBy: coachId,
    updatedby: coachId,
  };
  try {
    const response = await axiosInstance.post(
      `${Endpoints.END_CLIENT_SUBSCRIPTION}`,
      payload
    );

    return response;
  } catch (error) {
    throw error?.data?.message || "Something went wrong.";
  }
};
